
import { PerformanceCore } from './performance/performanceCore';
import { PerformanceMetrics } from '@/types/analytics';

/**
 * Main class for performance analytics that works with the analytics service
 */
export class PerformanceAnalytics {
  private performanceCore: PerformanceCore | null = null;
  private isInitialized: boolean = false;
  
  constructor() {
    try {
      // Only initialize in browser environment
      if (typeof window !== 'undefined') {
        this.performanceCore = new PerformanceCore();
      }
    } catch (error) {
      console.error('Failed to initialize PerformanceAnalytics:', error);
    }
  }
  
  /**
   * Initialize performance tracking
   */
  initializePerformanceTracking(): void {
    try {
      if (this.isInitialized || !this.performanceCore) {
        return;
      }
      
      this.performanceCore.initializePerformanceTracking();
      this.isInitialized = true;
    } catch (error) {
      console.error('Error initializing performance tracking:', error);
    }
  }
  
  /**
   * Get current performance metrics
   */
  getCurrentMetrics(): PerformanceMetrics {
    if (!this.performanceCore) {
      return {};
    }
    
    try {
      return this.performanceCore.getCurrentMetrics();
    } catch (error) {
      console.error('Error getting performance metrics:', error);
      return {};
    }
  }
  
  /**
   * Clean up resources
   */
  cleanup(): void {
    try {
      if (this.performanceCore) {
        this.performanceCore.disconnect();
        this.isInitialized = false;
      }
    } catch (error) {
      console.error('Error cleaning up performance analytics:', error);
    }
  }
}
